import ArrowRightThin from '@assets/icons/arrow-right-thin.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Pressable, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface SearchCatalogFooterProps {
  onPress: () => void;
}

/**
 * Footer shown at the end of OG search results.
 * Prompts user to search the catalog if they can't find what they're looking for.
 */
export const SearchCatalogFooter: React.FC<SearchCatalogFooterProps> = ({
  onPress,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container}>
      <Typography color={theme.sk.color.text.secondary} variant="paragraph-md">
        {i18n.t('sales_portal.order_entry.search_catalog_footer.prompt')}
      </Typography>
      <Pressable
        accessibilityLabel={i18n.t(
          'sales_portal.order_entry.search_catalog_footer.cta',
        )}
        accessibilityRole="link"
        onPress={onPress}
        style={styles.ctaContainer}
      >
        <Typography variant="paragraph-md-600">
          {i18n.t('sales_portal.order_entry.search_catalog_footer.cta')}
        </Typography>
        <ArrowRightThin
          fill={theme.sk.color.icon.primary}
          height={16}
          width={16}
        />
      </Pressable>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
    justifyContent: 'center',
    marginTop: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceMedium,
  },
  ctaContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
  },
}));
